import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

export interface EventqScheduleBlockTimeRow {
  readonly label: string;
  readonly range: string;
}

/** Pre-formatted hover details for a schedule timeline block (Figma 8146:84012). */
export interface EventqScheduleBlockDetails {
  readonly title: string;
  readonly timeRows: readonly EventqScheduleBlockTimeRow[];
  readonly nvrs: readonly string[];
  readonly createdBy: string;
}

@Component({
  selector: 'eventq-schedule-block-tooltip',
  templateUrl: './schedule-block-tooltip.html',
  styleUrl: './schedule-block-tooltip.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    'data-testid': 'schedule-block-tooltip',
    class: 'eventq-schedule-block-tooltip',
  },
})
export class EventqScheduleBlockTooltip {
  readonly details = input.required<EventqScheduleBlockDetails>();

  readonly showNvrs = computed(() => this.details().nvrs.length > 0);
  readonly showCreatedBy = computed(() => this.details().createdBy.trim().length > 0);
}
